import * as actionTypes from "../ActionTypes";

const initialState = {
  loading: false,
  galleryList: [],
  error: null,
  success: false,
  savedGallery: null,
};

const galleryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SAVE_GALLERY_REQUEST:
    case actionTypes.READ_GALLERY_REQUEST:
    case actionTypes.DELETE_GALLERY_REQUEST:
    case actionTypes.UPDATE_GALLERY_IMAGE_REQUEST:
      return { ...state, loading: true, success: false, error: null };

    case actionTypes.SAVE_GALLERY_SUCCESS:
      return { ...state, loading: false, success: true, savedGallery: action.payload };

    case actionTypes.READ_GALLERY_SUCCESS:
      return { ...state, loading: false, success: true, galleryList: action.payload?.data || [] };

    case actionTypes.DELETE_GALLERY_SUCCESS:
    case actionTypes.UPDATE_GALLERY_IMAGE_SUCCESS:
      return { ...state, loading: false, success: true };

    case actionTypes.SAVE_GALLERY_FAILURE:
    case actionTypes.READ_GALLERY_FAILURE:
    case actionTypes.DELETE_GALLERY_FAILURE:
    case actionTypes.UPDATE_GALLERY_IMAGE_FAILURE:
      return { ...state, loading: false, success: false, error: action.payload };
      case actionTypes.GET_IMAGE_BASE64_REQUEST:
        return { ...state, loading: true, error: null };
      
      case actionTypes.GET_IMAGE_BASE64_SUCCESS:
        return { ...state, loading: false, success: true, base64Image: action.payload };
      
      case actionTypes.GET_IMAGE_BASE64_FAILURE:
        return { ...state, loading: false, success: false, error: action.payload };
      
    default:
      return state;
  }
};

export default galleryReducer;
